import { render, staticRenderFns } from "./addAdminModal.vue?vue&type=template&id=7d185f2a&scoped=true"
import script from "./addAdminModal.vue?vue&type=script&lang=js"
export * from "./addAdminModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d185f2a",
  null
  
)

export default component.exports